import React, { useState } from "react";
import Company from "./Company";
import Personal from "./Personal";
import { useSelector } from "react-redux";

const Form = ({ data, content, industries, primary_interests }) => {
  const step = useSelector((state) => state.fetchSignup.step);
  const [page, setPage] = useState(0);

  // DISABLE-VERIFICATION: Authentication (OTP) step removed from signup flow.
  // TO REVERT: add `<Authentication data={data} />` back as index 2, restore Authentication import,
  // and change Math.min(step, 1) back to plain `step`.
  const componentList = [
    <Personal content={content} />,
    <Company content={content} industries={industries} primary_interests={primary_interests} />,
  ];
  return <>{componentList[Math.min(step, 1)]}</>;
};

export default Form;
